/** IDs de pasos para la página Filosofía de tratamiento (sin imágenes). */
export const DR_APPROACH_VISUAL_STEP_IDS = ['v1', 'v2', 'v3', 'v4'];
